var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.908 40",
    enableBackground: "new 0 0 39.908 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M12.531,7.389h14.937c0.444,0,0.809-0.363,0.809-0.808V0H11.721v6.58 C11.721,7.026,12.084,7.389,12.531,7.389L12.531,7.389z M12.531,7.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M39.375,10.062l-8.43-8.465V6.58c0,1.916-1.559,3.476-3.476,3.476H12.531c-1.916,0-3.476-1.56-3.476-3.476 V0H3.67C1.643,0,0,1.643,0,3.67v32.661C0,38.356,1.643,40,3.67,40h32.66c2.026,0,3.67-1.643,3.67-3.669V11.573 C39.999,11.006,39.775,10.462,39.375,10.062L39.375,10.062z M33.777,31.583c0,1.182-0.959,2.142-2.143,2.142H8.363 c-1.183,0-2.141-0.96-2.141-2.142V20.416c0-1.182,0.959-2.141,2.141-2.141h23.271c1.184,0,2.143,0.96,2.143,2.141V31.583z  M33.777,31.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M29.194,21.712H10.805c-0.737,0-1.334,0.595-1.334,1.333c0,0.738,0.597,1.334,1.334,1.334h18.389 c0.736,0,1.333-0.596,1.333-1.334C30.527,22.308,29.93,21.712,29.194,21.712L29.194,21.712z M29.194,21.712"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39B54A",
    d: "M26.528,27.046H13.471c-0.736,0-1.331,0.596-1.331,1.333c0,0.736,0.596,1.333,1.331,1.333h13.057 c0.735,0,1.332-0.597,1.332-1.333C27.86,27.642,27.264,27.046,26.528,27.046L26.528,27.046z M26.528,27.046"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6b012c54a8980149d998b4ab12ff2453.svg";
export { ForwardRef as ReactComponent };